'use client'

import { SITE_RECAPTCHA_KEY } from '@/config/site'
import { useCallback, useEffect, useState } from 'react'

export const useCaptcha = () => {
  const [token, setToken] = useState<string | null>(null)

  useEffect(() => {
    if (
      SITE_RECAPTCHA_KEY != null &&
      SITE_RECAPTCHA_KEY.length === 0 &&
      window.grecaptcha != null
    ) {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(SITE_RECAPTCHA_KEY!, { action: 'submit' })
          .then((token: string) => {
            setToken(token)
          })
      })
    }
  }, [])

  const getToken = useCallback(async () => {
    if (SITE_RECAPTCHA_KEY == null || SITE_RECAPTCHA_KEY.length === 0) {
      return
    }

    return await window.grecaptcha.execute(SITE_RECAPTCHA_KEY!, {
      action: 'submit',
    })
  }, [])

  return { token, getToken }
}
